const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;

// Slim bar under the video: playback progress plus a marker for each question.
export const QuestionTimeline = ({ cps, answers, now, duration }) => {
  if (!duration) return null;
  return (
    <div className="relative h-5" data-testid="question-timeline">
      <div className="absolute inset-x-0 top-1/2 h-1.5 -translate-y-1/2 overflow-hidden rounded-full bg-slate-200">
        <div className="h-full bg-blue-500/70 transition-[width] duration-200" style={{ width: `${Math.min(100, (now / duration) * 100)}%` }} />
      </div>
      {cps.map((c, i) => {
        const a = answers[c.id];
        const tone = !a ? "bg-white border-slate-500" : a.correct ? "bg-green-500 border-green-700" : "bg-rose-500 border-rose-700";
        return (
          <span key={c.id} title={`Q${i + 1} · ${fmt(c.time)}`} style={{ left: `${Math.min(100, (c.time / duration) * 100)}%` }}
            className={`group absolute top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 cursor-default rounded-full border-2 ${tone}`} data-testid={`timeline-marker-${i}`}>
            <span className="pointer-events-none absolute bottom-full left-1/2 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-slate-900 px-1.5 py-0.5 text-[10px] font-medium text-white opacity-0 transition-opacity group-hover:opacity-100">Q{i + 1} · {fmt(c.time)}</span>
          </span>
        );
      })}
    </div>
  );
};
